export default function() {
  return {
    totalItems: 0,
    page: 1,
    limit: 10,
    result: [],
    TiposEvento: [],
    Catalogo: [],
    OpcionesCotizacionList: [],
    OpcionCotizacionDetails: [],
    CotizacionesList: [],
    Cotizacion: []
  }
}
